import { render, staticRenderFns } from "./RegistrationFormContent.vue?vue&type=template&id=465ac3dc&scoped=true&"
import script from "./RegistrationFormContent.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ac3dc",
  null
  
)

export default component.exports